<button class="text-only-button dialog-close-button" (click)="buttonClick.emit()" id="btn-fermer">
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
    <title>{{ 'btn.fermer' | translate }}</title>
    <g stroke="#666" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
      <path d="M.375 11.624L11.625.374M11.625 11.624L.375.374" transform="translate(1 1)" />
    </g>
  </svg>
</button>
